import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadHostComponentsFailed, loadHostComponentsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadHostComponents(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/hosts/${id}/components`;
    const pool = {};
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      yield put(loadHostComponentsSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson.result));
    } else {
      yield put(loadHostComponentsFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadHostComponentsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
